import { ApiIncidentType, IncidentStatusEnum } from "@store/types";

export type GroupedPastIncidentsType = {
    [key: string]: ApiIncidentType[];
};

export const getGroupedPastIncidents = (incidents: ApiIncidentType[], { days } = { days: 4 }) => {
    const now = new Date();
    now.setUTCHours(0, 0, 0, 0);

    return Array.from({ length: days })
        .map((_, i) => {
            const day = new Date(now);
            day.setUTCDate(day.getUTCDate() - i);
            return day;
        })
        .reduce<GroupedPastIncidentsType>(
            (acc, day) => ({
                ...acc,
                [day.toISOString()]: incidents.filter((incident) =>
                    incident.status === IncidentStatusEnum.RESOLVED
                        ? day.getTime() ===
                          new Date(incident.updated_at || incident.created_at).setUTCHours(
                              0,
                              0,
                              0,
                              0,
                          )
                        : day.getTime() === now.getTime(),
                ),
            }),
            {},
        );
};
